import { z } from "zod";
import apiClient from "../../../shared/api/client";
import type { ContactMessage, ContactMessageStatus, ContactMessagesListResponse } from "../types";

const contactMessageSchema = z.object({
  id: z.string(),
  name: z.string(),
  email: z.string(),
  subject: z.string(),
  message: z.string(),
  status: z.enum(["unread", "read", "replied"]),
  createdAt: z.string(),
  updatedAt: z.string(),
});

const contactMessagesListResponseSchema = z.object({
  data: z.array(contactMessageSchema),
  total: z.number(),
});

export const fetchContactMessages = async (): Promise<ContactMessagesListResponse> => {
  const response = await apiClient.get("/contact");
  return contactMessagesListResponseSchema.parse(response.data);
};

export const fetchContactMessage = async (id: string): Promise<ContactMessage> => {
  const response = await apiClient.get(`/contact/${id}`);
  return contactMessageSchema.parse(response.data);
};

export const updateContactStatus = async (
  id: string,
  status: ContactMessageStatus
): Promise<ContactMessage> => {
  const response = await apiClient.patch(`/contact/${id}/status`, { status });
  return contactMessageSchema.parse(response.data);
};
